import React, { useEffect, useState } from "react";
import { Grid, Box, Stack, Chip, Typography, Paper, Backdrop, CircularProgress } from "@mui/material";
import TreeView from "@mui/lab/TreeView";
import TreeItem from "@mui/lab/TreeItem";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import axiosBaseURL from "../../../utilities/httpCommon";
import { GetDetailsofCC, addCustomXmlPart } from "../../../utilities/Wordutil";
import OfficeAddinMessageBar from "./OfficeAddinMessageBar";
//import process = require("process");

/* global Word console  */
//axios.defaults.baseURL = process.env.REACT_APP_API_KEY;

const Insertfield = (props: any) => {
  const defaultobj = [{ name: "Agreement__c", list: [] }];
  const [mainlst, setmainlst] = useState(defaultobj);
  const [isprogress, setprogress] = useState(false);
  //const [open, setopen] = useState(false);
  const [isloading, setisloading] = useState(false);
  const [selmainobj, setSelmainobj] = useState("");
  const [treeviewdata, settreeviewdata] = useState([]);
  const [currentNode, setCurrentNode] = useState("");
  const [currentNodes, setCurrentNodes] = useState([]);
  const [mntreeviewdata, setmntreeviewdata] = useState([]);
  const [errMsgd, seterrMsgd] = useState("");

  const errorDismissed = () => {
    seterrMsgd("");
  };

  //const [selectedIndex, setSelectedIndex] = React.useState(0);
  //const [subselectedIndex, setsubSelectedIndex] = React.useState(-1);

  // const inputStyle = {
  //   border: 0,
  //   borderColor: "lightgray",
  //   maxHeight: 120,
  //   overflow: "auto",
  // };

  // const inputStyleborder = {
  //   border: 1,
  //   borderColor: "lightgray",
  //   maxHeight: 120,
  //   overflow: "auto",
  // };

  useEffect(() => {
    console.log("Triggered");
    console.log(props.tablecondition);
    console.log(props.mainfldid);
    SetInitialData();
  }, [props.mainfldid, props.tablemode]);

  // async function SetInsertTableData(id: any) {
  //   console.log("Loading fields....");
  //   setprogress(true);
  //   await SetFieldsforTreeview(id);
  //   setSelmainobj(id);
  //   setprogress(false);
  // }

  // function GetLabelfromAll(resallobjs, sobjname) {
  //   let findobj = resallobjs.find((x) => x.name === sobjname);
  //   console.log(findobj);
  //   if (findobj != null) {
  //     return findobj.label;
  //   } else {
  //     return sobjname;
  //   }
  // }

  async function SetInitialData() {
    if (!props.tablemode) {
      const obj = [{ name: "Agreement__c", list: [] }];
      if (props.tablecondition) {
        let arrrefs = [];
        let resultall = await fetchData("globalall", true);
        await Word.run(async (context) => {
          let getseltable = context.document.getSelection().parentTableOrNullObject;
          if (getseltable != null) {
            context.load(getseltable);
            await context.sync();
            let getselparent = getseltable.parentContentControlOrNullObject;
            context.load(getselparent);
            await context.sync();
            if (getselparent.id != undefined) {
              console.log(getselparent.id);
              let details = await GetDetailsofCC(getselparent.id);
              console.log(details);
              let mainname = details.name;
              console.log("Main Name...");
              console.log(mainname);
              if (mainname.indexOf(".") > 0) {
                let flatarray = mainname.split(".");
                console.log(flatarray);
                let lastitem = "";
                for (var i = 0; i < flatarray.length; i++) {
                  if (i === 0) {
                    arrrefs.push({
                      id: flatarray[i],
                      label: GetLabelfromAll(resultall, flatarray[i]),
                      name: flatarray[i],
                      children: [],
                    });
                  } else {
                    console.log(arrrefs);
                    console.log(lastitem);
                    let fnditem = findValue(arrrefs, lastitem);
                    console.log("Find Item....");
                    console.log(fnditem);
                    if (fnditem != undefined) {
                      fnditem.children.push({
                        id: flatarray[i],
                        label: GetLabelfromAll(resultall, flatarray[i]),
                        name: flatarray[i],
                        children: [],
                      });
                    }
                  }
                  lastitem = flatarray[i];
                  console.log(lastitem);
                }
              }
              setmntreeviewdata(arrrefs);
            }
          }
        });
      }
      setmainlst(obj);
      let mainid = mainlst[0].name;
      await SetFieldsforTreeview(mainid);
      setSelmainobj(mainid);
    } else if (props.tablemode) {
      setprogress(true);
      await SetFieldsforTreeview(props.mainfldid);
      setprogress(false);
      setSelmainobj(props.mainfldid);
    }
  }

  const fetchData = async (name: string, childrelation: boolean) => {
    try {
      setisloading(true);
      seterrMsgd("");
      //Check for expired token
      // /auth/whoami
      // const checktoken = await axios.get("/auth/whoami", {
      //   withCredentials: true,
      // });
      // console.log(checktoken);
      // console.log("CHECK");
      // console.log(checktoken.data);
      // if (checktoken.data === undefined || checktoken.data === null || checktoken.data === "") {
      //   const reftoken = await axios.get("/auth/getrefreshtoken?q=" + localStorage.getItem("refreshtoken"), {
      //     headers: {
      //       Authorization: "Bearer ".concat(localStorage.getItem("tokenvalue")),
      //     },
      //   });
      //   if (reftoken.data != null) {
      //     localStorage.setItem("tokenvalue", reftoken.data.access_token);
      //   }
      //   console.log(reftoken);
      // }
      //Ends here
      console.log("name:=> " + name);
      const res = await axiosBaseURL
        .get("/sfserver/getmetadata?object=" + name, {
          withCredentials: true,
        })
        .catch((error) => {
          console.log("error==");
          console.log(error);
          setisloading(false);
          if (error.response) {
            seterrMsgd(error.response.data);
          } else if (error.request) {
            seterrMsgd(error.request);
          } else {
            seterrMsgd(error.message);
          }
        });
      setisloading(false);
      if (res.data != null) {
        if (name === "globalall") return res.data.sobjects;
        if (!childrelation) return res.data.fields;
        else if (childrelation) return res.data.childRelationships;
      } else return null;
    } catch (err) {
      if (err.response) {
        console.log(err.response.data);
        console.log(err.response.status);
        console.log(err.response.headers);
      } else if (err.request) {
        console.log(err.request);
      } else {
        console.log("Error", err.message);
      }
      setisloading(false);
    }
  };

  // const onClick = async (id: string) => {
  //   await SetFieldsforTreeview(id);
  //   setSelmainobj(id);
  // };

  async function SetFieldsforTreeview(id: string) {
    if (treeviewdata.length === 0 || id !== selmainobj) {
      console.log("main selection");
      console.log(id);
      let result = await fetchData(id, false);
      if (result != null) {
        let objfld = [];
        for (var node of result) {
          objfld.push({
            id: id + "." + node["name"],
            name: node["name"],
            label: node["label"],
            subfields: node["referenceTo"],
            children: [],
            relationshipname: node["relationshipName"],
            results: false,
            type: node["type"],
          });
        }
        settreeviewdata(objfld);
      }
    }
  }

  /*** Treeview  */
  const treestyle = {
    "& .MuiTreeItem-label": {
      fontSize: "15px",
      padding: 0.25,
    },
  };

  function GetLabelfromAll(resallobjs, sobjname) {
    let findobj = resallobjs.find((x) => x.name === sobjname);
    console.log(findobj);
    if (findobj != null) {
      return findobj.label;
    } else {
      return sobjname;
    }
  }

  const renderTreeMain = (node: any) => (
    <TreeItem sx={treestyle} key={node.name} nodeId={node.id} label={node.label}>
      {Array.isArray(node.children) && node.children.length
        ? node.children.map((subnode: any) => renderTreeMain(subnode))
        : null}
    </TreeItem>
  );

  const renderTree = (node: any) => (
    <Stack direction="row" justifyContent="space-between" spacing={0}>
      <TreeItem
        sx={treestyle}
        key={node.name}
        nodeId={node.id}
        label={Array.isArray(node.subfields) && node.subfields.length == 0 ? node.label : node.label + " ..."}
      >
        {Array.isArray(node.children) && node.children.length
          ? node.children.map((subnode: any) => renderTree(subnode))
          : null}
      </TreeItem>
      <Chip
        onClick={() => handleInsert(node)}
        label="Insert"
        color="primary"
        sx={
          Array.isArray(node.subfields) && node.subfields.length == 0 && currentNode === node.id && props.insertmode
            ? { height: "22px", display: "block", marginLeft: 1.4, marginRight: 1 }
            : { height: "22px", display: "none" }
        }
      />
    </Stack>
  );

  let findValue = (arr, val) => {
    for (let obj of arr) {
      if (obj.id === val) {
        return obj;
      }
      if (obj.children) {
        let result = findValue(obj.children, val);
        if (result) {
          return result;
        }
      }
    }
    return undefined;
  };

  const handleMainNodeSelect = async (_: any, nodeId: any) => {
    let selfldvalue = findValue(mntreeviewdata, nodeId);
    //if (selfldvalue != undefined && selfldvalue.name != defaultobj[0].name) {
    if (selfldvalue != undefined) {
      setSelmainobj(selfldvalue.name);
      await SetFieldsforTreeview(selfldvalue.name);
      console.log("Right selection => " + selfldvalue);
      console.log(selfldvalue);
    }
    //}
  };

  const handleInsert = async (selnode: any) => {
    console.log(currentNode);
    console.log("selnode: => ");
    console.log(selnode);
    let newnodexml = "";
    await Word.run(async (context) => {
      let selection = context.document.getSelection();
      var objcc = selection.insertContentControl(Word.ContentControlType.richText);
      objcc.title = "Fields";
      objcc.placeholderText = selnode.label;
      objcc.tag = selnode.id.replace(selmainobj + ".", "");
      objcc.load("id");
      await context.sync();
      var strnewrel = "";
      if (selnode.relationshipname != null) {
        strnewrel = selnode.relationshipname;
        strnewrel = strnewrel.replace(",null", "," + selnode.name);
        strnewrel = strnewrel.split(",").join(".");
      }
      newnodexml =
        "<field id='" +
        objcc.id +
        "'>" +
        "<name>" +
        selnode.name +
        "</name>" +
        "<label>" +
        selnode.label +
        "</label>" +
        "<conditions />" +
        "<reference>" +
        strnewrel +
        "</reference>" +
        "<type>" +
        selnode.type +
        "</type>" +
        "<sfvalue/>" +
        "</field>";
      await context.sync();
      objcc.getRange().select(Word.SelectionMode.end);
      await context.sync();
    });
    console.log("Passing XML value ....");
    console.log(newnodexml);
    await addCustomXmlPart(newnodexml);
  };

  const handleNodeSelect = async (_: any, nodeId: any) => {
    console.log("What ID:");
    console.log(nodeId);
    setCurrentNode(nodeId);
    setCurrentNodes(nodeId);
    if (!props.insertmode) {
      if (!props.tablemode) {
        let selfldvalue = findValue(treeviewdata, nodeId);
        console.log("selfldvalue: ");
        console.log(selfldvalue);
        var strnewrel = nodeId.replace(selmainobj + ".", "");
        if (selfldvalue.relationshipname != null) {
          strnewrel = selfldvalue.relationshipname;
          strnewrel = strnewrel.replace(",null", "," + selfldvalue.name);
          strnewrel = strnewrel.split(",").join(".");
        }
        props.setdlgvalue({ value: strnewrel, selobject: selfldvalue });
      } else if (props.tablemode) {
        let selndlist = [];
        nodeId.forEach((element) => {
          let selnodevalue = findValue(treeviewdata, element);
          if (selnodevalue != null) selndlist.push(selnodevalue);
        });
        props.setdlgvalue(selndlist);
      }
    }

    console.log("selected fields");
    console.log(nodeId);

    let slnodeID = nodeId;
    if (Array.isArray(nodeId)) {
      slnodeID = nodeId[0];
    }

    let nodevalue = findValue(treeviewdata, slnodeID);

    console.log("Selected list = ");
    console.log(nodevalue);
    if (
      nodevalue != null &&
      Array.isArray(nodevalue.subfields) &&
      nodevalue.subfields.length > 0 &&
      !nodevalue.results
    ) {
      if (nodevalue.subfields.length === 1) {
        let result = await fetchData(nodevalue.subfields[0], false);
        if (result != null) {
          let objfld = [];
          for (var node of result) {
            objfld.push({
              id: slnodeID + "." + node["name"],
              name: node["name"],
              label: node["label"],
              subfields: node["referenceTo"],
              children: [],
              results: false,
              relationshipname: nodevalue.relationshipname + "," + node["relationshipName"],
              type: node["type"],
            });
          }
          const newState = [...treeviewdata];
          const newnode = findValue(newState, slnodeID);
          if (newnode != undefined) {
            newnode.children = objfld;
            newnode.results = true;
          }
          settreeviewdata(newState);
        }
      } else if (nodevalue.subfields.length > 1) {
        let mainfld = [];
        for (var slbl of nodevalue.subfields) {
          let result = await fetchData(slbl, false);
          if (result != null) {
            mainfld.push({
              id: slnodeID + "." + slbl,
              name: slbl,
              label: slbl,
              subfields: [],
              children: [],
              results: true,
            });
            let objfld = [];
            for (var sbnode of result) {
              objfld.push({
                id: slnodeID + "." + slbl + "." + sbnode["name"],
                name: sbnode["name"],
                label: sbnode["label"],
                subfields: sbnode["referenceTo"],
                children: [],
                results: false,
                relationshipname: node["relationshipName"],
                type: sbnode["type"],
              });
            }
            mainfld[mainfld.length - 1].children = objfld;
          }
        }
        const newState = [...treeviewdata];
        const newnode = findValue(newState, slnodeID);
        if (newnode != undefined) {
          newnode.children = mainfld;
          newnode.results = true;
        }
        settreeviewdata(newState);
      }
    }
  };
  /*** Treeview  */

  return (
    <Box sx={{ p: 1, marginTop: 0, marginLeft: 0, marginRight: 0 }}>
      {errMsgd.length > 0 ? <OfficeAddinMessageBar onDismiss={errorDismissed} message={errMsgd + " "} /> : null}
      <Grid container spacing={1}>
        {!props.insertmode && (
          <Grid item xs={12} sx={{ height: 36, bgcolor: "#1C39BB", padding: 0, margin: 0 }}>
            <Typography sx={{ color: "white" }}>{props.title}</Typography>
          </Grid>
        )}
        <Grid item xs={12}>
          {!props.tablemode && (
            <>
              {isprogress ? (
                <Typography>Loading please wait ... </Typography>
              ) : (
                <>
                  {props.tablecondition ? (
                    <Paper
                      elevation={0}
                      sx={{
                        border: 1,
                        borderColor: "lightgray",
                        maxHeight: 120,
                        overflow: "auto",
                      }}
                    >
                      <TreeView
                        aria-label="rich object"
                        defaultCollapseIcon={<ExpandMore />}
                        defaultExpanded={[defaultobj[0].name]}
                        defaultExpandIcon={<ChevronRightIcon />}
                        onNodeSelect={handleMainNodeSelect}
                        sx={{
                          margintop: 0,
                          position: "relative",
                          height: "100vh",
                          flexGrow: 1,
                          maxWidth: 500,
                          overflowY: "auto",
                          overflowX: "hidden",
                        }}
                      >
                        {mntreeviewdata.map((node) => renderTreeMain(node))}
                      </TreeView>
                    </Paper>
                  ) : (
                    <Paper
                      elevation={0}
                      sx={{
                        border: 0,
                        borderColor: "lightgray",
                        maxHeight: 120,
                        overflow: "auto",
                      }}
                    >
                      <Typography sx={{ fontWeight: "bold" }}>Agreement</Typography>
                    </Paper>
                  )}
                </>
              )}
            </>
          )}
        </Grid>
        <Grid item xs={12}>
          <Paper elevation={0} sx={{ border: 1, borderColor: "lightgray", height: "100vh" }}>
            {!props.tablemode && (
              <TreeView
                aria-label="rich object"
                defaultCollapseIcon={<ExpandMore />}
                defaultExpanded={["root"]}
                defaultExpandIcon={<ChevronRightIcon />}
                sx={{ height: "100vh", flexGrow: 1, maxWidth: 500, overflowY: "auto", overflowX: "hidden" }}
                onNodeSelect={handleNodeSelect}
                selected={currentNode}
              >
                {treeviewdata.map((node) => renderTree(node))}
              </TreeView>
            )}
            {props.tablemode && (
              <TreeView
                aria-label="rich object"
                defaultCollapseIcon={<ExpandMore />}
                defaultExpanded={["root"]}
                defaultExpandIcon={<ChevronRightIcon />}
                sx={{ height: "100vh", flexGrow: 1, maxWidth: 500, overflowY: "auto", overflowX: "hidden" }}
                onNodeSelect={handleNodeSelect}
                selected={currentNodes}
                multiSelect
              >
                {treeviewdata.map((node) => renderTree(node))}
              </TreeView>
            )}
          </Paper>
        </Grid>
      </Grid>
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isloading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default Insertfield;
